export default function Contacts() {
  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-xl p-8 text-white shadow-lg">
        <h2 className="text-2xl font-bold mb-2">Contacts</h2>
        <p className="text-teal-100">Besoin d'aide ? Contactez-nous !</p>
      </div>

      <div className="bg-white rounded-xl p-8 shadow-lg">
        <p className="text-gray-700 mb-6">
          Notre équipe est disponible pour répondre à toutes vos questions. N'hésitez pas à nous contacter via WhatsApp ou Telegram.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <a
            href="https://whatsapp.com/channel/0029VbCEuEA1NCrMAsPILy3J"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center p-6 bg-gradient-to-r from-green-500 to-green-600 rounded-xl text-white hover:shadow-xl transition cursor-pointer"
          >
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mr-4">
              <i className="ri-whatsapp-line text-3xl"></i>
            </div>
            <div>
              <h3 className="font-bold text-lg mb-1">WhatsApp</h3>
              <p className="text-sm text-green-100">Support rapide</p>
            </div>
          </a>

          <a
            href="https://t.me/+RLed8IfVgMINDg0"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center p-6 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl text-white hover:shadow-xl transition cursor-pointer"
          >
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mr-4">
              <i className="ri-telegram-line text-3xl"></i>
            </div>
            <div>
              <h3 className="font-bold text-lg mb-1">Telegram</h3>
              <p className="text-sm text-blue-100">Communauté active</p>
            </div>
          </a>
        </div>

        <div className="bg-teal-50 rounded-lg p-6">
          <h3 className="font-bold text-gray-800 mb-3 flex items-center">
            <i className="ri-time-line text-teal-600 mr-2"></i>
            Horaires de support
          </h3>
          <p className="text-gray-700">
            Notre équipe est disponible 24/7 pour répondre à vos questions et vous accompagner dans votre parcours sur SUCCESSLINK AGENCY.
          </p>
        </div>
      </div>
    </div>
  );
}